exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".collection-inspiration .background-inspiration{bottom:0;height:52%}", ""]);

